import React from "react";
import { connect } from "react-redux";
import SideMenuLayout from "../components/layout/SideMenu";
import { getLocation, push } from "connected-react-router";
import { userSubscription } from "../store/sales/selectors";
import { getUser } from "../store/iam/selectors";

const SideBar = ({ currentPath, push, userSubscription, user }) => {
  return (
    <SideMenuLayout selectedMenuItem={currentPath} onMenuItemClick={push} user={user} subscription={userSubscription} />
  );
};

const mapStateToProps = state => ({
  currentPath: getLocation(state).pathname,
  userSubscription: userSubscription(state),
  user: getUser(state)
});

export default connect(mapStateToProps, { push })(SideBar);
